// Su Tesisatı Mock Data
// Boru, vana, armatür ve sıhhi tesisat takibi

export const suTesisatiMalzemeler = [
    {
        id: 'su-001',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-09',
        tedarikci: 'Pipelife Türkiye',
        tedarikciFirmaId: 'f-050',
        kategori: 'boru',
        urunAdi: 'PPR Boru Ø20',
        aciklama: 'Temiz su borusu',
        miktar: 500,
        birim: 'metre',
        birimFiyat: 35,
        toplamFiyat: 17500,
        durum: 'teslim',
        stokMiktar: 150,
        kullanilanMiktar: 350,
        uygulamaYeri: 'A Blok Kolon',
        insaatId: 'c-001',
        not: 'Kolon tesisatı için',
        createdAt: '2026-01-08T08:00:00Z',
        updatedAt: '2026-01-15T16:00:00Z',
    },
    {
        id: 'su-002',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-09',
        tedarikci: 'Pipelife Türkiye',
        tedarikciFirmaId: 'f-050',
        kategori: 'boru',
        urunAdi: 'PPR Boru Ø32',
        aciklama: 'Ana hat borusu',
        miktar: 300,
        birim: 'metre',
        birimFiyat: 65,
        toplamFiyat: 19500,
        durum: 'teslim',
        stokMiktar: 80,
        kullanilanMiktar: 220,
        uygulamaYeri: 'A Blok Ana Hat',
        insaatId: 'c-001',
        not: 'Bodrum kat ana dağıtım',
        createdAt: '2026-01-08T08:00:00Z',
        updatedAt: '2026-01-14T14:00:00Z',
    },
    {
        id: 'su-003',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-11',
        tedarikci: 'Wavin Pilsa',
        tedarikciFirmaId: 'f-051',
        kategori: 'boru',
        urunAdi: 'PVC Atık Borusu Ø100',
        aciklama: 'Pis su borusu',
        miktar: 400,
        birim: 'metre',
        birimFiyat: 85,
        toplamFiyat: 34000,
        durum: 'teslim',
        stokMiktar: 100,
        kullanilanMiktar: 300,
        uygulamaYeri: 'A Blok Şaft',
        insaatId: 'c-001',
        not: 'Şaft tesisatı',
        createdAt: '2026-01-10T09:00:00Z',
        updatedAt: '2026-01-16T15:00:00Z',
    },
    {
        id: 'su-004',
        siparisTarihi: '2026-01-12',
        teslimTarihi: '2026-01-13',
        tedarikci: 'Eca Vana',
        tedarikciFirmaId: 'f-052',
        kategori: 'vana',
        urunAdi: 'Küresel Vana 1/2"',
        aciklama: 'Daire giriş vanası',
        miktar: 40,
        birim: 'adet',
        birimFiyat: 120,
        toplamFiyat: 4800,
        durum: 'teslim',
        stokMiktar: 15,
        kullanilanMiktar: 25,
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        not: 'Daire giriş tesisatı',
        createdAt: '2026-01-12T10:00:00Z',
        updatedAt: '2026-01-17T11:00:00Z',
    },
    {
        id: 'su-005',
        siparisTarihi: '2026-01-14',
        teslimTarihi: null,
        tedarikci: 'Vitra',
        tedarikciFirmaId: 'f-053',
        kategori: 'armatur',
        urunAdi: 'Lavabo Bataryası',
        aciklama: 'S50 Serisi Krom',
        miktar: 40,
        birim: 'adet',
        birimFiyat: 850,
        toplamFiyat: 34000,
        durum: 'bekliyor',
        stokMiktar: 0,
        kullanilanMiktar: 0,
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        montajDurumu: 'bekliyor',
        not: 'Fayans bitince montaj',
        createdAt: '2026-01-14T14:00:00Z',
        updatedAt: '2026-01-14T14:00:00Z',
    },
    {
        id: 'su-006',
        siparisTarihi: '2026-01-14',
        teslimTarihi: null,
        tedarikci: 'Vitra',
        tedarikciFirmaId: 'f-053',
        kategori: 'vitrifiye',
        urunAdi: 'Klozet Takımı',
        aciklama: 'S20 Asma Klozet + Rezervuar',
        miktar: 40,
        birim: 'adet',
        birimFiyat: 3500,
        toplamFiyat: 140000,
        durum: 'bekliyor',
        stokMiktar: 0,
        kullanilanMiktar: 0,
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        montajDurumu: 'bekliyor',
        not: 'Son aşamada montaj',
        createdAt: '2026-01-14T14:00:00Z',
        updatedAt: '2026-01-14T14:00:00Z',
    },
];

// Su tesisatı kategorileri
export const suTesisatiKategorileri = [
    { key: 'boru', label: 'Boru', icon: '🔧' },
    { key: 'vana', label: 'Vana', icon: '🔩' },
    { key: 'armatur', label: 'Armatür', icon: '🚿' },
    { key: 'vitrifiye', label: 'Vitrifiye', icon: '🚽' },
    { key: 'pompa', label: 'Pompa', icon: '⚙️' },
];

// İstatistikler
export const getSuTesisatiStats = (insaatId) => {
    const filtered = insaatId
        ? suTesisatiMalzemeler.filter(s => s.insaatId === insaatId)
        : suTesisatiMalzemeler;

    const toplamKalem = filtered.length;
    const teslimEdilen = filtered.filter(s => s.durum === 'teslim').length;
    const bekleyen = filtered.filter(s => s.durum === 'bekliyor').length;
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);

    return {
        toplamKalem,
        teslimEdilen,
        bekleyen,
        toplamMaliyet,
    };
};

// Helper: insaata göre filtrele
export const getSuTesisatiByInsaat = (insaatId) => {
    if (!insaatId) return suTesisatiMalzemeler;
    return suTesisatiMalzemeler.filter(s => s.insaatId === insaatId);
};

// Helper: kategoriye göre filtrele
export const getSuTesisatiByKategori = (kategori, insaatId) => {
    let data = insaatId ? getSuTesisatiByInsaat(insaatId) : suTesisatiMalzemeler;
    if (kategori) {
        data = data.filter(s => s.kategori === kategori);
    }
    return data;
};
